import { createRouter, createWebHistory } from 'vue-router'
import routes from '~pages'
import { useTheme } from '../composables/useTheme'

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// テーマ管理のグローバルインスタンス
const themeInstance = useTheme()

// ダッシュボードのテーマ状態を保存する変数
let dashboardThemeState = null

// ダッシュボードから離脱時にライトモードに変更
router.beforeEach((to, from, next) => {
  // ダッシュボードページから他のページへ移動する場合
  if (to.path === '/') {
    // 現在のテーマ状態を保存
    dashboardThemeState = themeInstance.theme.value
    themeInstance.setTheme('light')
  }
  
  // TOPページからダッシュボードに戻る場合
  if (to.path.startsWith('/dashboard') && dashboardThemeState) {
    // 保存されたテーマ状態を復元
    themeInstance.setTheme(dashboardThemeState)
  }
  
  next()
})

export default router
